import { UniqueContainerId } from "./UniqueContainerId";
var UniqueContainerSet = /** @class */ (function () {
    function UniqueContainerSet(values) {
        var _this = this;
        this.map = new Map();
        values === null || values === void 0 ? void 0 : values.forEach(function (value) {
            var toInsert = _this.getKey(value);
            _this.map.set(toInsert.toString(), value);
        });
    }
    UniqueContainerSet.prototype.add = function (value) {
        var toInsert = this.getKey(value);
        this.map.set(toInsert.toString(), value);
        return this;
    };
    UniqueContainerSet.prototype.addAll = function (values) {
        var _this = this;
        values.forEach(function (container) {
            _this.add(container);
        });
        return this;
    };
    UniqueContainerSet.prototype.clear = function () {
        this.map.clear();
    };
    UniqueContainerSet.prototype.size = function () {
        return this.map.size;
    };
    UniqueContainerSet.prototype["delete"] = function (value) {
        var toDelete = this.getKey(value);
        return this.map["delete"](toDelete.toString());
    };
    UniqueContainerSet.prototype.forEach = function (callbackfn, thisArg) {
        var _this = this;
        this.map.forEach(function (value, key, set) {
            callbackfn.apply(thisArg, [
                value,
                UniqueContainerId.fromString(key),
                _this,
            ]);
        });
    };
    UniqueContainerSet.prototype.values = function () {
        return this.map.values();
    };
    UniqueContainerSet.prototype.get = function (key) {
        var accessKey = this.getKey(key);
        return this.map.get(accessKey.toString());
    };
    UniqueContainerSet.prototype.has = function (value) {
        var toInsert = this.getKey(value);
        return this.map.has(toInsert.toString());
    };
    UniqueContainerSet.prototype.getKey = function (value) {
        if (UniqueContainerSet.isContainerTreeData(value)) {
            return new UniqueContainerId(value.id, value.containerType);
        }
        if (!(value instanceof UniqueContainerId)) {
            return UniqueContainerId.fromObject(value);
        }
        return value;
    };
    UniqueContainerSet.isContainerTreeData = function (data) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return data.containerType !== undefined;
    };
    return UniqueContainerSet;
}());
export { UniqueContainerSet };
//# sourceMappingURL=UniqueContainerSet.js.map